module.exports = __webpack_public_path__ + "04532a5ae5f9005fbc0bf1a3dea2e496.MP3";